<template>
  <div class="flex items-center justify-center gap-1">
    <check-marker
      :key="prefixKey('marker', item.id)"
      :item="{ id: item.id, marker: item.marker, target: 'order' }"
      :size="16"
    />
    <note-entry
      :options="{
        name: item.container_no,
        id: item.id,
        type: 'Container',
        category: 'admin',
        noted: item.admin_noted,
      }"
      :key="prefixKey('notes', item.id)"
      :size="16"
    />
    <container-colorify
      :item="{ id: item.id, color: item.color }"
      :key="prefixKey('colorify', item.id)"
      :size="16"
    />
  </div>
</template>

<script>
export default {
  name: "order-status-action",
  props: {
    item: Object,
    options: Object,
  },
};
</script>
